var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"zov-spin-bars-chrome-loading"},[_c('circle',{staticClass:"zov-spin-bars-chrome-loading-path",attrs:{"cx":"0.5em","cy":"0.5em","r":"0.4em"}})])}
var staticRenderFns = []

export { render, staticRenderFns }